<div
  class="default-borders"
  [style.border-top-width]="customProps['border'] ?? customProps['border-top']"
  [style.border-bottom-width]="customProps['border'] ?? customProps['border-bottom']"
  [style.border-left-width]="customProps['border'] ?? customProps['border-left']"
  [style.border-right-width]="customProps['border'] ?? customProps['border-right']"
  [style.margin-top]="customProps['margin'] ?? customProps['margin-top']"
  [style.margin-bottom]="customProps['margin'] ?? customProps['margin-bottom']"
  [style.margin-left]="customProps['margin'] ?? customProps['margin-left']"
  [style.margin-right]="customProps['margin'] ?? customProps['margin-right']"
>
  @for (field of field.fieldGroup; track $index) {
    <formly-field class="flex-1" [field]="field"></formly-field>
  }
</div>
